import { getFiltersMap } from '../../../../components/Table/utils';

type FilterItem = {
  name: string;
  value: any;
  operator?: 'equals' | 'gt' | 'lt' | 'between' | 'gte' | 'lte' | 'eq' | 'contains';
};

export function buildFiltersObject(filterArray: FilterItem[]) {
  const filtersMap = getFiltersMap();
  const filtersObj: Record<string, any> = {};

  filterArray.forEach(({ name, value, operator }) => {
    if (value === '' || value === null || value === undefined) return;

    const paramName = filtersMap.has(name) ? filtersMap.get(name) : name;
    const paramNameStr = String(paramName);

    if (typeof value === 'number' || (!isNaN(value) && value !== '')) {
      const numValue = typeof value === 'number' ? value : parseFloat(value);
      filtersObj[paramNameStr] = numValue;

      switch (operator) {
        case 'equals':
          if (paramNameStr.toLowerCase().includes('year')) {
            filtersObj[`min_${paramNameStr}`] = numValue;
            filtersObj[`max_${paramNameStr}`] = numValue;
          } else {
            filtersObj[`min_${paramNameStr}`] = numValue - 0.05;
            filtersObj[`max_${paramNameStr}`] = numValue + 0.05;
          }
          break;

        case 'eq':
          if (paramNameStr.toLowerCase().includes('year')) {
            filtersObj[`min_${paramNameStr}`] = numValue;
            filtersObj[`max_${paramNameStr}`] = numValue;
          } else if (
            paramNameStr.toLowerCase().includes('score') ||
            paramNameStr.toLowerCase().includes('ei')
          ) {
            filtersObj[`min_${paramNameStr}`] = numValue - 0.005;
            filtersObj[`max_${paramNameStr}`] = numValue + 0.005;
          } else {
            filtersObj[`min_${paramNameStr}`] = numValue - 0.05;
            filtersObj[`max_${paramNameStr}`] = numValue + 0.05;
          }
          break;

        case 'gt':
          if (paramNameStr.toLowerCase().includes('score') || paramNameStr.toLowerCase().includes('ei')) {
            filtersObj[`min_${paramNameStr}`] = numValue + 0.005;
          } else {
            filtersObj[`min_${paramNameStr}`] = numValue + 1;
          }
          break;

        case 'lt':
          if (
            paramNameStr.toLowerCase().includes('score') ||
            paramNameStr.toLowerCase().includes('ei') ||
            paramNameStr.toLowerCase().includes('dsi') ||
            paramNameStr.toLowerCase().includes('dpi') ||
            paramNameStr.toLowerCase().includes('pli') ||
            paramNameStr.toLowerCase().includes('sokal')
          ) {
            filtersObj[`max_${paramNameStr}`] = numValue - 0.005;
          } else {
            filtersObj[`max_${paramNameStr}`] = numValue - 1;
          }
          break;

        case 'between':
          if (Array.isArray(value) && value.length === 2) {
            filtersObj[`min_${paramNameStr}`] = parseFloat(value[0]);
            filtersObj[`max_${paramNameStr}`] = parseFloat(value[1]);
          }
          break;
        case 'gte':
          filtersObj[`min_${paramNameStr}`] = numValue;
          break;
        case 'lte':
          filtersObj[`max_${paramNameStr}`] = numValue;
          break;
        default:
          if (
            paramNameStr.includes('year') ||
            paramNameStr.includes('Year') ||
            paramNameStr.includes('numPMIDsupportingAssociation')
          ) {
            filtersObj[`min_${paramNameStr}`] = numValue;
            filtersObj[`max_${paramNameStr}`] = numValue;
          } else {
            filtersObj[`min_${paramNameStr}`] = numValue - 0.05;
            filtersObj[`max_${paramNameStr}`] = numValue + 0.05;
          }
      }
    } else {
      let normalizedValue = value;
      if (operator === 'contains') {
        if (Array.isArray(value)) {
          normalizedValue = value.map(v => `contains_${String(v)}`);
        } else if (typeof value === 'string') {
          normalizedValue = `contains_${value}`;
        }
      }
      filtersObj[paramNameStr] = normalizedValue;
    }
  });

  return filtersObj;
}
